import { render, staticRenderFns } from "./MaterialDamageList.vue?vue&type=template&id=3a18d052"
import script from "./MaterialDamageList.vue?vue&type=script&lang=js"
export * from "./MaterialDamageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports